
define('text!templates/modules/calendar/nutrition/food/details/details-form.html',[],function () { return '<div class="food-details">\n    <h4>{{#t}}food-details{{/t}}</h4>\n    <div class="food-name">{{#t}}name{{/t}}</div>\n    <div class="tc-row">\n        <div class="food-serving tc-col-lg-6 tc-col-md-6 tc-col-xs-12">{{#t}}serving{{/t}}</div>\n    </div>\n</div>\n';});

